/*
    This is a utility constant file to store label and redirect link of quick link card component of the dashboard page.
*/

export const SENIORITY_LIST_JOB_AIDS_URL_LABEL = 'Seniority List Job Aids';
export const SENIORITY_LIST_JOB_AIDS_URL =
  'https://wnco.sharepoint.com/:b:/r/sites/SWALife-TechOps-Secure/Shared%20Documents/Work%20Essentials/Workforce%20Navigator/Seniority%20List%20Job%20Aid.pdf?csf=1&web=1&e=u5hIlz';
export const MY_HOURS_JOB_AIDS_URL_LABEL = 'My Hours Job Aids';
export const MY_HOURS_JOB_AIDS_URL =
  'https://wnco.sharepoint.com/:b:/r/sites/SWALife-TechOps-Secure/Shared%20Documents/Work%20Essentials/Workforce%20Navigator/MyHours%20Job%20Aid.pdf?csf=1&web=1&e=dAb0QE';
